import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "icon-sizes"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#icon-sizes" }),
  /*#__PURE__*/_createTextVNode(" Icon Sizes ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" The font icons can be sized using "),
  /*#__PURE__*/_createElementVNode("code", null, ".fs-{size}"),
  /*#__PURE__*/_createTextVNode(" class that defined with "),
  /*#__PURE__*/_createElementVNode("code", null, "$font-sizes"),
  /*#__PURE__*/_createTextVNode(" variable in "),
  /*#__PURE__*/_createElementVNode("code", null, "sass/_variables.scss")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("code", null, "size", -1)
const _hoisted_6 = { class: "pt-3" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<li class=\"py-2\"><code>7</code> - sets icon size that equals to <code>0.95 of $font-size-base</code> where <code>$font-size-base: 1rem</code></li><li class=\"py-2\"><code>8</code> - sets icon size that equals to <code>0.85 of $font-size-base</code> where <code>$font-size-base: 1rem</code></li><li class=\"py-2\"><code>9</code> - sets icon size that equals to <code>0.75 of $font-size-base</code> where <code>$font-size-base: 1rem</code></li><li class=\"py-2\"><code>10</code> - sets icon size that equals to <code>0.5 of $font-size-base</code> where <code>$font-size-base: 1rem</code></li><li class=\"py-2\"><code>base</code> - sets icon size that equals to <code>$font-size-base</code> where <code>$font-size-base: 1rem</code></li><li class=\"py-2\"><code>fluid</code> - sets icon size that equals to <code>100%</code></li>", 6)
const _hoisted_13 = { class: "py-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("code", null, "$font-size-base: 1rem", -1)
const _hoisted_15 = { class: "py-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("code", null, "$font-size-base: 1rem", -1)
const _hoisted_17 = { class: "py-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("code", null, "$font-size-base: 1rem", -1)
const _hoisted_19 = { class: "py-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("code", null, "$font-size-base: 1rem", -1)
const _hoisted_21 = { class: "py-5" }
const _hoisted_22 = { class: "rounded border d-flex flex-wrap p-10" }
const _hoisted_23 = { class: "d-flex flex-center flex-grow-1" }
const _hoisted_24 = { class: "fw-bold py-2 text-center" }
const _hoisted_25 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(" Where "),
      _hoisted_5,
      _createTextVNode(" is one of: "),
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (i) => {
          return _createElementVNode("li", {
            key: i,
            class: "py-2"
          }, [
            _createElementVNode("code", null, _toDisplayString(i), 1),
            _createTextVNode(" - sets icon size that equals to "),
            _createElementVNode("code", null, "<h" + _toDisplayString(i++) + ">", 1),
            _createTextVNode(" font size ")
          ])
        }), 64)),
        _hoisted_7,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([2, 3, 4, 5], (i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            _createElementVNode("li", _hoisted_13, [
              _createElementVNode("code", null, _toDisplayString(i) + "x", 1),
              _createTextVNode(" - sets icon size that equals to "),
              _createElementVNode("code", null, _toDisplayString(i) + " of $font-size-base", 1),
              _createTextVNode(" where "),
              _hoisted_14
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createElementVNode("code", null, _toDisplayString(i) + "qx", 1),
              _createTextVNode(" - sets icon size that equals to "),
              _createElementVNode("code", null, _toDisplayString(i) + ".25 of $font-size-base", 1),
              _createTextVNode(" where "),
              _hoisted_16
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createElementVNode("code", null, _toDisplayString(i) + "hx", 1),
              _createTextVNode(" - sets icon size that equals to "),
              _createElementVNode("code", null, _toDisplayString(i) + ".5 of $font-size-base", 1),
              _createTextVNode(" where "),
              _hoisted_18
            ]),
            _createElementVNode("li", _hoisted_19, [
              _createElementVNode("code", null, _toDisplayString(i) + "tx", 1),
              _createTextVNode(" - sets icon size that equals to "),
              _createElementVNode("code", null, _toDisplayString(i) + ".75 of $font-size-base", 1),
              _createTextVNode(" where "),
              _hoisted_20
            ])
          ], 64))
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizes, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "d-flex flex-column h-100px w-100px me-10 mb-5"
          }, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("i", {
                class: _normalizeClass([`fs-${item}`, "bi bi-droplet-half"])
              }, null, 2)
            ]),
            _createElementVNode("div", _hoisted_24, ".fs-" + _toDisplayString(item), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<i class="bi bi-droplet-half fs-5x"></i>
        <i class="bi bi-droplet-half fs-4x"></i>
        <i class="bi bi-droplet-half fs-3x"></i>
        <i class="bi bi-droplet-half fs-2tx"></i>
        <i class="bi bi-droplet-half fs-2hx"></i>
        <i class="bi bi-droplet-half fs-2qx"></i>
        <i class="bi bi-droplet-half fs-2x"></i>
        <i class="bi bi-droplet-half fs-1"></i>
        <i class="bi bi-droplet-half fs-2"></i>
        <i class="bi bi-droplet-half fs-3"></i>
        <i class="bi bi-droplet-half fs-5"></i>
        <i class="bi bi-droplet-half fs-6"></i>`))
        ]),
        _: 1
      })
    ])
  ]))
}